import React, { useEffect, useState } from 'react'
import useAnimate from '../../hooks/useAnimate';
// import material ui
import { makeStyles } from '@material-ui/core';
import { Snackbar, Alert } from '@mui/material';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import DashboardButtonBack from '../../_components/DashboardButtonBack';
import DashboardAnimate from '../../_components/DashboardAnimate';
import Preloader from '../../_components/Preloader';
import IntegrationRequest from './components/Request';
import LinkTo from '../../_components/LinkTo';
// redux
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
// import image
import DashboardBanner from '../../_components/DashboardBanner';
// import router
import { useParams } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 1246,
        margin: "0 auto",
        padding: "0 15px",
        overflowX: "hidden",
    },

    body: {
        padding: "50px 0 30px 0",
        [theme.breakpoints.down(768)]: {
            padding: "30px 0 15px 0"
        },
    },

    content: {
        paddingTop: 32,
        display: "grid",
        gap: 32,
        [theme.breakpoints.down(960)]: {
            gap: 15,
            paddingTop: 15,
        },
    },

    back: {
        paddingBottom: "50px",
        [theme.breakpoints.down(768)]: {
            paddingBottom: "30px",
        },
    },

    item: {
        paddingTop: 32,
        paddingBottom: 32,
        [theme.breakpoints.down(476)]: {
            paddingTop: 16,
            paddingBottom: 16,
        },

        fontSize: 14,
        fontWeight: 400,
        color: "black",

        "& article": {
            color: "#FF392B",
            fontSize: 16,
            fontWeight: 700,
        },

        "& a": {
            color: "#2F80ED",
        },

        "& h2": {
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.3,
            paddingBottom: 46,
            [theme.breakpoints.down(960)]: {
                paddingBottom: 32,
            },
        },

        "& ul": {
            paddingLeft: 0,
        },

        "& ul li": {
            paddingBottom: 15,
            [theme.breakpoints.down(960)]: {
                paddingBottom: 15,
            },
        },

        "& ul li h3": {
            paddingBottom: 25,
            [theme.breakpoints.down(960)]: {
                paddingBottom: 15,
            },
        },

        "& ul li ol": {
            listStyleType: "decimal",
        },

        "& ul li ol li": {
            paddingBottom: 0,
        },

        "& h3": {
            fontSize: 14,
            fontWeight: 600,
            color: "#1C2A53",
        },

        "& img": {
            width: "100%",
            padding: "25px 0",
        },
    },

    item_gap: {
        display: "grid",
        gap: 32,
        [theme.breakpoints.down(960)]: {
            gap: 15,
        },
    },

    title_link: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 10,

        "& img": {
            maxWidth: 209,
            width: "100%",
            height: 75,
            objectFit: "contain",
            objectPosition: "left",
            padding: 0,
        },
    },

    key_wrapper: {
        display: "grid",
        gap: 16,
    },

    key: {
        display: "flex",
        alignItems: "center",
        gap: 16,

        "& input": {
            maxWidth: 525,
            width: "100%",
            boxSizing: "border-box",
            padding: 10,
            border: "0.8px solid #8E95A9",
            borderRadius: 4,
            color: "#8E95A9",
            fontSize: 13,
            fontWeight: 600,
        },

        "& button": {
            cursor: "pointer",
            backgroundColor: "transparent",
            border: 0,

            "&:hover": {
                "& svg": {
                    fill: "black"
                },
            },

            "& svg": {
                transition: "0.3s",
                fill: "#C8CAD8",
            },
        },
    },
}));

const IntegrationPage = (props) => {
    const {
        userSelectedData,
        integrationByType,
        getIntegrationByType,
    } = props;
    useAnimate();
    const { slug } = useParams();
    const classes = useStyles();
    const { t } = useTranslation();
    const [snack, setSnack] = useState({
        active: false,
        variant: "",
        text: "",
    });

    useEffect(() => {
        getIntegrationByType(slug, userSelectedData?.customer_code);
    }, []);

    const createMarkup = () => {
        return {
            __html: integrationByType?.data?.instruction,
        };
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setSnack({
                    active: true,
                    variant: "success",
                    text: t('common:copied_btn'),
                });
            })
            .catch(err => {
                console.error('Помилка при копіюванні: ', err);
            });
    };

    const handleCloseAction = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnack({
            active: false,
            variant: "",
            text: "",
        });
    };

    const action = (
        <React.Fragment>
            <btn onClick={handleCloseAction}>UNDO</btn>
        </React.Fragment>
    );

    return (
        <main className="dashboard">
            <DashboardBanner />
            <div className={classes.container}>
                <div className={classes.body}>
                    <div className={classes.back}><DashboardButtonBack /></div>
                    <h1 className="dashboard__title">{t('common:integration_label')} {slug === "xml" ? "PROM" : slug === "json" ? "JSON" : slug === "csv" ? "CSV" : slug === "nova-poshta" ? "НОВОЇ ПОШТИ" : null}</h1>
                    <DashboardAnimate style={{ transform: "scale(0.97)" }}>
                        <div className={classes.content}>
                            {integrationByType?.loading || integrationByType?.error ? (
                                <div className={`dashboard-card ${classes.item} ${classes.item_gap}`}>
                                    {integrationByType?.loading && (
                                        <div className="dashboard-card-empty">
                                            <Preloader />
                                        </div>
                                    )}
                                    {integrationByType?.error && (
                                        <div className="dashboard-card-empty">
                                            {t("common:unknown_error_label")}
                                        </div>
                                    )}
                                    <div className={classes.title_link}>
                                        <span style={{ fontSize: "45px", fontWeight: "700" }}>LOGO</span>
                                        <LinkTo title={"Перейти на сайт"} adaptive={true} path={"/"} />
                                    </div>
                                    <p>{t('common:integration_title')}</p>
                                    <article><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49294 0.0148544L7.10694 0.0548544C5.23394 0.241854 3.34694 1.20785 2.07094 2.63385C0.65994 4.21085 -0.0570602 6.16785 0.00893984 8.25285C0.12394 11.8539 2.59894 14.9029 6.10994 15.7709C7.14366 16.0205 8.21665 16.0624 9.2667 15.8942C10.3167 15.7259 11.3229 15.3509 12.2269 14.7909C14.0047 13.6832 15.2772 11.9224 15.7709 9.88685C15.9429 9.18585 15.9829 8.82885 15.9829 7.99985C15.9829 7.17085 15.9429 6.81385 15.7709 6.11285C14.9789 2.87785 12.3149 0.497854 8.99994 0.0638544C8.71594 0.0268544 7.68294 -0.00614561 7.49294 0.0148544ZM8.85294 1.56285C9.97621 1.71072 11.0416 2.14879 11.9439 2.83385C12.2729 3.07985 12.9199 3.72685 13.1659 4.05585C13.7269 4.80685 14.1419 5.68985 14.3299 6.53485C14.544 7.4998 14.544 8.49991 14.3299 9.46485C13.9159 11.3259 12.6049 12.9779 10.8669 13.8279C10.2404 14.1345 9.57009 14.3423 8.87994 14.4439C8.45594 14.5089 7.54394 14.5089 7.11994 14.4439C5.17194 14.1479 3.52794 13.0849 2.49294 11.4509C2.23836 11.0288 2.026 10.5826 1.85894 10.1189C1.62075 9.43817 1.50398 8.72094 1.51394 7.99985C1.51394 6.96085 1.71494 6.07485 2.15994 5.15985C2.49994 4.46185 2.84594 3.97985 3.41294 3.41285C3.91445 2.89268 4.50642 2.46809 5.15994 2.15985C6.30497 1.60052 7.58999 1.39278 8.85294 1.56285ZM7.70594 4.28985C7.48194 4.36285 7.35494 4.49085 7.29294 4.70485C7.25694 4.82685 7.25294 5.10585 7.25894 6.81585C7.26694 8.78585 7.26694 8.78685 7.32494 8.89585C7.40114 9.03548 7.52343 9.14434 7.67094 9.20385C7.80294 9.24985 8.19694 9.24985 8.32894 9.20385C8.47645 9.14434 8.59874 9.03548 8.67494 8.89585C8.73294 8.78685 8.73294 8.78585 8.74094 6.81585C8.74894 4.66385 8.74894 4.66185 8.59594 4.48085C8.47194 4.33285 8.33894 4.28385 8.03994 4.27585C7.92842 4.26957 7.81655 4.27426 7.70594 4.28985ZM7.78594 10.5299C7.58587 10.6014 7.41946 10.7447 7.31894 10.9319C7.24675 11.1112 7.23793 11.3098 7.29394 11.4949C7.34801 11.6397 7.44408 11.7652 7.56985 11.8551C7.69562 11.9451 7.84537 11.9955 7.99994 11.9999C8.30294 11.9999 8.61194 11.7799 8.70594 11.4949C8.76195 11.3098 8.75313 11.1112 8.68094 10.9319C8.59816 10.7858 8.47807 10.6643 8.33294 10.5799C8.21694 10.5199 7.90394 10.4909 7.78594 10.5299Z" fill="#FF392B" />
                                    </svg> Завершився термін дії API Key</article>
                                    <div className={classes.key_wrapper}>
                                        <div className={classes.key}>
                                            <input type="text" value="https://new-api.daniparts.com/csv/?key=c065afdb-ca20-11ed-ab69-d778f27e9002" readonly />
                                            <button onClick={() => copyToClipboard("https://new-api.daniparts.com/csv/?key=c065afdb-ca20-11ed-ab69-d778f27e9002")}>
                                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M24.6875 0.25H7.6875C7.40571 0.25 7.13546 0.361942 6.9362 0.561199C6.73694 0.760457 6.625 1.03071 6.625 1.3125V6.625H1.3125C1.03071 6.625 0.760457 6.73694 0.561199 6.9362C0.361942 7.13546 0.25 7.40571 0.25 7.6875V24.6875C0.25 24.9693 0.361942 25.2395 0.561199 25.4388C0.760457 25.6381 1.03071 25.75 1.3125 25.75H18.3125C18.5943 25.75 18.8645 25.6381 19.0638 25.4388C19.2631 25.2395 19.375 24.9693 19.375 24.6875V19.375H24.6875C24.9693 19.375 25.2395 19.2631 25.4388 19.0638C25.6381 18.8645 25.75 18.5943 25.75 18.3125V1.3125C25.75 1.03071 25.6381 0.760457 25.4388 0.561199C25.2395 0.361942 24.9693 0.25 24.6875 0.25ZM17.25 23.625H2.375V8.75H17.25V23.625ZM23.625 17.25H19.375V7.6875C19.375 7.40571 19.2631 7.13546 19.0638 6.9362C18.8645 6.73694 18.5943 6.625 18.3125 6.625H8.75V2.375H23.625V17.25Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div className={classes.key}>
                                            <input type="text" value="https://new-api.daniparts.com/csv/?key=c065afdb-ca20-11ed-ab69-d778f27e9002" readonly />
                                            <button onClick={() => copyToClipboard("https://new-api.daniparts.com/csv/?key=c065afdb-ca20-11ed-ab69-d778f27e9002")}>
                                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M24.6875 0.25H7.6875C7.40571 0.25 7.13546 0.361942 6.9362 0.561199C6.73694 0.760457 6.625 1.03071 6.625 1.3125V6.625H1.3125C1.03071 6.625 0.760457 6.73694 0.561199 6.9362C0.361942 7.13546 0.25 7.40571 0.25 7.6875V24.6875C0.25 24.9693 0.361942 25.2395 0.561199 25.4388C0.760457 25.6381 1.03071 25.75 1.3125 25.75H18.3125C18.5943 25.75 18.8645 25.6381 19.0638 25.4388C19.2631 25.2395 19.375 24.9693 19.375 24.6875V19.375H24.6875C24.9693 19.375 25.2395 19.2631 25.4388 19.0638C25.6381 18.8645 25.75 18.5943 25.75 18.3125V1.3125C25.75 1.03071 25.6381 0.760457 25.4388 0.561199C25.2395 0.361942 24.9693 0.25 24.6875 0.25ZM17.25 23.625H2.375V8.75H17.25V23.625ZM23.625 17.25H19.375V7.6875C19.375 7.40571 19.2631 7.13546 19.0638 6.9362C18.8645 6.73694 18.5943 6.625 18.3125 6.625H8.75V2.375H23.625V17.25Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : integrationByType?.data?.is_active ? (
                                <>
                                    <div className={`dashboard-card ${classes.item} ${classes.item_gap}`}>
                                        {integrationByType?.data?.image || integrationByType?.data?.url_site ? (
                                            <div className={classes.title_link}>
                                                {integrationByType?.data?.image && <img src={integrationByType?.data?.image} alt={integrationByType?.data?.name || "Логотип"} />}
                                                {integrationByType?.data?.url_site &&
                                                    <div className='link-to'>
                                                        <a
                                                            href={integrationByType?.data?.url_site}
                                                            target='_blank'>
                                                            <span>{t('common:go_to_site')}</span>
                                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1.33337 5.99998H10.6667M10.6667 5.99998L6.00004 1.33331M10.6667 5.99998L6.00004 10.6666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </a>
                                                    </div>}
                                            </div>
                                        ) : null}
                                        <div className="dashboard-structure" dangerouslySetInnerHTML={{ __html: integrationByType?.data?.description_name }} />
                                        <div className={classes.key_wrapper}>
                                            <div className={classes.key}>
                                                <input type="text" value={integrationByType?.data?.url_integration || t("common:error_generation_label")} readonly />
                                                <button onClick={() => copyToClipboard(integrationByType?.data?.url_integration || t("common:error_generation_label"))}>
                                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M24.6875 0.25H7.6875C7.40571 0.25 7.13546 0.361942 6.9362 0.561199C6.73694 0.760457 6.625 1.03071 6.625 1.3125V6.625H1.3125C1.03071 6.625 0.760457 6.73694 0.561199 6.9362C0.361942 7.13546 0.25 7.40571 0.25 7.6875V24.6875C0.25 24.9693 0.361942 25.2395 0.561199 25.4388C0.760457 25.6381 1.03071 25.75 1.3125 25.75H18.3125C18.5943 25.75 18.8645 25.6381 19.0638 25.4388C19.2631 25.2395 19.375 24.9693 19.375 24.6875V19.375H24.6875C24.9693 19.375 25.2395 19.2631 25.4388 19.0638C25.6381 18.8645 25.75 18.5943 25.75 18.3125V1.3125C25.75 1.03071 25.6381 0.760457 25.4388 0.561199C25.2395 0.361942 24.9693 0.25 24.6875 0.25ZM17.25 23.625H2.375V8.75H17.25V23.625ZM23.625 17.25H19.375V7.6875C19.375 7.40571 19.2631 7.13546 19.0638 6.9362C18.8645 6.73694 18.5943 6.625 18.3125 6.625H8.75V2.375H23.625V17.25Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {integrationByType?.data?.instruction && (
                                        <div className={`dashboard-card ${classes.item}`}>
                                            <div className="dashboard-structure" dangerouslySetInnerHTML={createMarkup()} />
                                        </div>
                                    )}
                                </>
                            ) : <IntegrationRequest slug={slug} setSnack={setSnack} />}
                        </div>
                    </DashboardAnimate>
                </div>
            </div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                open={snack?.active}
                action={action}
                autoHideDuration={3000}
                onClose={handleCloseAction}
                message="Скопійовано">
                <Alert severity={snack?.variant} variant="filled">
                    {snack?.text}
                </Alert>
            </Snackbar>
        </main>
    )
}

function mapState(state) {
    const {
        userSelectedData,
        integrationByType,
    } = state;
    return {
        userSelectedData,
        integrationByType,
    };
}

const actionCreators = {
    getIntegrationByType:
        userActions.getIntegrationByType,
};

export default connect(mapState, actionCreators)(IntegrationPage);